import { Alert, AlertTitle, Button, Checkbox, FormControlLabel, FormGroup, Paper, Stack, TextField, Typography } from "@mui/material"
import { useState, useReducer } from "react"
import { Link } from "react-router-dom"
import { z } from "zod"

import config from "../../common/Config";

const Register = () => {
	
	const [inputFields, dispatch]					= useReducer(reducer, {isValid: false})

	const [isButtonDisabled, setIsButtonDisabled] 	= useState(true)
	const [returnObject, setReturnObject]			= useState()
	const [highlightErrors, setHighlightErrors]		= useState(false)

	const handleSubmit = (e) => {
		// Verifica se tudo está ok e se sim, envia para criação
		if (inputFields.isValid) {
			fetch(config.apiUrl +'/register', {	
				method : 'POST',
				headers : {
					'content-type' : 'application/json; charset=utf-8',
				},
				body : JSON.stringify({
					name		: inputFields.name,
					email		: inputFields.email,
					username	: inputFields.username,	 
					password	: inputFields.password
				})
			})
			.then(result => result.json())
			.then(result => {
				let message		= 'Ocorreu um erro ao criar usuario!';

				// Se retornou erro, destaca os campos com erro
				if (result.status === 500) { 
					if (result.errorCode === 'DUPLICATE_EMAIL_EXCEPTION') {
						dispatch({type: 'appendError', field: 'email', payload: 'E-mail já cadastrado!'})
						setHighlightErrors(true)
					}
					
					if (result.errorCode === 'DUPLICATE_USER_EXCEPTION') {
						dispatch({type: 'appendError', field: 'username', payload: 'Username já cadastrado!'})
						setHighlightErrors(true)
					}
				}
				else {
					message = 'Você se registrou com sucesso! Enviamos um e-mail para validação do cadastro. Verifique sua caixa de entrada para prosseguir com seu cadastro!'
				}

				setReturnObject({
					status 	: result.status === 200 ? "success" :  "error",
					message	: message
				})
			})
			.catch(err => {
				setReturnObject({
					status 	: 'error',
					message	: err.message
				})
			})
		}
		else {
			setHighlightErrors(true)
		}

		return false
	}

	return (
		<Paper sx={{martinTop:0, martinBottom:4, marginLeft: 2, marginRight: 4, height:'88vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }} elevation={1}>
			{returnObject?.status === 'success' ? (
				<Stack direction="column" padding={2} spacing={1} sx={{width: '50%', overflowX: 'auto'}} onSubmit={handleSubmit} noValidate>
					<Typography variant='h6'>CADASTRE-SE</Typography>
					<Alert severity={returnObject.status}>
						<AlertTitle>Sucesso!</AlertTitle>
						{returnObject.message}
					</Alert>
				</Stack>
			) : (
				<Stack direction="column" padding={2} spacing={1} sx={{width: '50%', overflowX: 'auto'}} onSubmit={handleSubmit} noValidate>
					<Typography variant='h6'>CADASTRE-SE</Typography>
					{ returnObject?.status === 'error' ? <Alert severity={returnObject.status} onClose={() => setReturnObject(null)}>{returnObject.message}</Alert> : null }
					<TextField 
						label="Nome Completo" 
						name="name"
						value={inputFields.name || ''}
						onChange={(e) => dispatch({type: 'update', field : 'name', payload: e.target.value})}
						error={highlightErrors && inputFields.errors?.name}
						helperText={highlightErrors && inputFields.errors?.name}					
					/>
					<TextField 
						label="Username"
						name="username"
						value={inputFields.username || ''}
						onChange={(e) => dispatch({type: 'update', field : 'username', payload: e.target.value})}
						error={highlightErrors && inputFields.errors?.username}
						helperText={highlightErrors && inputFields.errors?.username}		
					/>			
					<TextField 
						label="Email" 
						name="email"
						value={inputFields.email || ''}
						onChange={(e) => dispatch({type: 'update', field : 'email', payload: e.target.value})}
						error={highlightErrors && inputFields.errors?.email}
						helperText={highlightErrors && inputFields.errors?.email}		
					/>
					<TextField 
						label="Senha" 				
						name="password"					
						type="password" 					
						value={inputFields.password || ''}
						onChange={(e) => dispatch({type: 'update', field : 'password', payload: e.target.value})}
						error={highlightErrors && inputFields.errors?.password}
						helperText={highlightErrors && inputFields.errors?.password}		
					/>
					<TextField 
						label="Repita a senha"
						name="retypedPassword"
						type="password" 
						value={inputFields.retypedPassword || ''}
						onChange={(e) => dispatch({type: 'update', field : 'retypedPassword', payload: e.target.value})}
						error={highlightErrors && inputFields.errors?.retypedPassword}
						helperText={highlightErrors && inputFields.errors?.retypedPassword}	
					/>
					<FormGroup>
						<FormControlLabel 
							control={<Checkbox onChange={e => setIsButtonDisabled(e.target.checked ? false : true)}/>} 
							label={
								<Typography variant="subtitle2">
									Eu li e aceito os <Link to={'/termos-de-uso.html'} target="_blank">Termos de Uso</Link> e 
									a <Link to={'/politica-de-privacidade.html'} target="_blank">Política de Privacidade</Link> do site
								</Typography>
							}
						/>
					</FormGroup>
					<Button variant="contained" type="submit" sx={{width: 200}} disabled={isButtonDisabled} onClick={handleSubmit}>Cadastrar-se</Button>
				</Stack>
			)}
		</Paper>

	)	
}

const reducer = (inputFields, action) => {
	let updatedFields = inputFields

	switch (action.type) {

		case 'update' : {
			updatedFields = {
				...updatedFields,
				[action.field] : action.payload
			}
			break;
		}

		case 'appendError' : {
			updatedFields.isValid = false
			updatedFields.errors = {
				...updatedFields.errors,
				[action.field] : action.payload
			}

			return updatedFields
		}

	}

	const zodParseResults = inputFieldsSchema.safeParse(updatedFields)

	updatedFields.isValid 	= zodParseResults.success
	updatedFields.errors	= parseZodErrors(zodParseResults)

	return updatedFields
}

const inputFieldsSchema = z.object({
	name 				: z.string({required_error: 'Preencha o nome.'}).trim().min(1, {message: 'Nome inválido.'}),
	username 			: z.string({required_error: 'Preencha o username.'}).regex(/^[a-zA-Z0-9.\-_]{6,}$/, {message: 'Username precisar ter no mínimo 6 caracteres entre letras, números, ponto, hífen e underscore.'}),
	email				: z.string({required_error: 'Preencha o e-mail.'}).email({message: 'E-mail inválido'}),
	password			: z.string({required_error: 'Preencha o password.'}),
	retypedPassword		: z.string(),
}).refine(data => data.password === data.retypedPassword, {
  message: "As senhas devem ser idênticas.",
  path: ["retypedPassword"]
});

const parseZodErrors = (pErrors) => {
	return pErrors.error?.issues?.reduce( (errors, e) => ({...errors, [e.path[0]] : e.message}), {})
}

export default Register